var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "teas-cell-item mobile" },
    [
      _vm.icon || _vm.label
        ? _c(
            "div",
            { staticClass: "cell-item-left" },
            [
              _vm._t("icon", function () {
                return [
                  _vm.icon
                    ? _c("i", {
                        staticClass: "teas-cell-item-icon",
                        class: ["iconfont", _vm.icon],
                      })
                    : _vm._e(),
                ]
              }),
              _vm._t("label", function () {
                return [
                  _vm.label
                    ? _c("span", { staticClass: "teas-cell-item-label" }, [
                        _vm._v(" " + _vm._s(_vm.label) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._t("value", function () {
        return [
          _c("div", { class: ["teas-cell-item-value", _vm.valueClass] }, [
            _vm._v(_vm._s(_vm.value)),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }